var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHackerNewsGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6H34V34H6V6ZM13.004 11.2126L18.8511 22.166V29.3625H21.1V22.2983L27 11.2126H24.513L21.0206 18.1445C20.8442 18.5149 20.6723 18.8721 20.5047 19.216C20.3371 19.56 20.1828 19.8819 20.0417 20.1817C19.9888 20.0406 19.927 19.8863 19.8565 19.7187C19.7859 19.5511 19.7066 19.3792 19.6184 19.2028C19.6007 19.1675 19.5831 19.1278 19.5654 19.0837C19.5478 19.0396 19.5213 18.9911 19.4861 18.9382C19.4332 18.7971 19.3714 18.6604 19.3009 18.5281C19.2303 18.3958 19.1686 18.268 19.1157 18.1445L15.6762 11.2126H13.004Z",
    fill: "white"
  })));
}

export default SvgHackerNewsGlyph;